import { render, staticRenderFns } from "./fenghuanghu_vr.vue?vue&type=template&id=18996204"
import script from "./fenghuanghu_vr.vue?vue&type=script&lang=js"
export * from "./fenghuanghu_vr.vue?vue&type=script&lang=js"
import style0 from "./fenghuanghu_vr.vue?vue&type=style&index=0&id=18996204&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports